import { ApplicationRequest, PaymentApiResponse } from '../types/api';
import { InitPaymentRequest, InitPaymentResponse } from '../types/api/payment';
import { paymentApi } from './base';

const postPayment = paymentApi.injectEndpoints({
  endpoints: (builder) => ({
    postPayment: builder.mutation<
      PaymentApiResponse<InitPaymentResponse>,
      { body: InitPaymentRequest | ApplicationRequest; params: boolean }
    >({
      query: ({ body, params }) => ({
        url: `?initPayment=${params}`,
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { usePostPaymentMutation } = postPayment;
